import React, { Component, ReactNode, useState, useEffect, Fragment } from 'react';
import { FlatList, Modal, SafeAreaView, StyleSheet, Text, View } from 'react-native';
import Touchable from './Touchable';
// import UserInput from './UserInput';
import { TextInput, Dialog, Portal } from 'react-native-paper';
import colors from '../../colors';
import { MAX_WIDTH_MODAL, TXT_M } from '../../constants';
import CModal from './CModal';

type Props = {
  list: Array<any>;
  onChange: (a: any) => void;
  value: any;
  getItemLabel: (a: any) => string;
  getItemValue?: (a: any) => string | number;
  title?: string;
  hideProcurar?: boolean;
};

export const CustomPicker: React.FC<Props> = (props) => {
  const { list, onChange, getItemLabel, getItemValue, title, value, hideProcurar } = props;
  const [dadosFiltrados, setDadosFiltrados] = useState(list);
  const [show, setShow] = useState(false);

  const [itemSelecionado, setItemSelecionado] = useState<any>(null);

  useEffect(() => {
    if (list) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (getItemValue && getItemValue(item) === value) {
          setItemSelecionado(item);
        }
      }
    }
  }, [value]);

  useEffect(() => {
    if (list) {
      filtrar();
    }
  }, [list]);

  const filtrar = (txt = '') => {
    let novosDadosFiltrados = list;
    if (txt !== '') {
      novosDadosFiltrados = list.filter((item) => {
        return getItemLabel(item).toUpperCase().indexOf(txt.toUpperCase()) != -1;
      });
    }

    setDadosFiltrados(novosDadosFiltrados);
  };

  const submit = (value) => {
    setDadosFiltrados(list);
    setShow(false);
    onChange(value);
  };

  return (
    <Fragment>
      <CModal mostrarModal={show} onClose={() => submit(null)}>
        {title && <Dialog.Title>{title}</Dialog.Title>}
        <Dialog.Content>
          {!hideProcurar && (
            <TextInput
              placeholderTextColor="#ACB8BB"
              placeholder="Pesquisar..."
              secureTextEntry={false}
              onChangeText={(txt) => {
                // setBusca(txt)
                filtrar(txt);
              }}
              style={{ marginBottom: 15 }}
              // mode="outlined"
            />
          )}

          <FlatList
            data={dadosFiltrados}
            keyExtractor={(item, index) => 'customPicker' + index}
            keyboardShouldPersistTaps={'always'}
            renderItem={(obj) => {
              return (
                <Touchable style={styles.itemResposta} onPress={() => submit(obj.item)}>
                  <Text>{getItemLabel(obj.item)}</Text>
                </Touchable>
              );
            }}
          />
        </Dialog.Content>
        <Dialog.Actions style={{ justifyContent: 'space-around' }}>
          <Touchable style={styles.btnCancel} onPress={() => submit(null)}>
            <Text>Cancelar</Text>
          </Touchable>
        </Dialog.Actions>
      </CModal>

      <Touchable style={styles.selectView} onPress={() => setShow(true)}>
        <Text style={styles.value}>
          {itemSelecionado ? getItemLabel(itemSelecionado) : 'Clique para selecionar'}
        </Text>
      </Touchable>
    </Fragment>
  );
};

// const DEVICE_WIDTH = Dimensions.get('window').width;
// const DEVICE_HEIGHT = Dimensions.get('window').height;

const styles = StyleSheet.create({
  btnCancel: {
    backgroundColor: colors.lightGrey,
    color: '#fff',
    padding: 10,
    borderRadius: 7,
    alignSelf: 'stretch',
    alignItems: 'center'
  },
  background: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.7)',
    justifyContent: 'center',
    alignItems: 'center'
  },
  popup: {
    backgroundColor: 'rgba(255,255,255,1)',
    opacity: 1,
    margin: 10,
    maxHeight: '95%',
    minWidth: '80%',
    padding: 25,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: '#EEF5F6'
  },
  itemResposta: {
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10,
    marginBottom: 10
  },
  selectView: {
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10
  },
  value: {
    fontSize: TXT_M
  }
});
